export default {"src":"/_next/static/media/facebookIcon.fff3d828.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};